import { sha256 } from "@noble/hashes/sha2.js";
import { bytesToHex, utf8ToBytes } from "@noble/hashes/utils.js";

export function reconnectVerifier(token: string): string {
  if (token.length < 1 || token.length > 128) throw new TypeError("Invalid reconnect token");
  return bytesToHex(sha256(utf8ToBytes(JSON.stringify(["kilnfront-reconnect-v1", token]))));
}
